<template>
  <nav class="navbar">
    <div class="CONTAINER pt5 pb5">
      <section class="wrapper">
        <button
          type="button"
          class="burger"
          :class="{ active: isActive }"
          @click="toggleBurger"
        >
          <span class="burger-line"></span>
          <span class="burger-line"></span>
          <span class="burger-line"></span>
          <span class="burger-line"></span>
        </button>
        <div class="menu" :class="{ active: isActive }" ref="menuRef">
          <ul class="menu-inner">
            <li v-for="(r, i) in mainPages" :key="i">
              <router-link
                class="menu-link"
                @click="toggleBurger"
                :to="{ name: r.routeName, params: $route.params }"
                >{{ r.title }}</router-link
              >
            </li>
          </ul>
        </div>
      </section>
    </div>
  </nav>
</template>

<script>
import { ref, reactive, watch, computed, toRefs } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "Header",
  setup() {
    const menuRef = ref();
    const store = useStore();
    const router = useRouter();
    const { currentRoute } = router;

    //* State
    const state = reactive({
      isActive: false,
      pageChildren: computed(() => store.getters["purl/getPageChildren"](1)),
      mainPages: computed(() => store.getters["purl/getPagesMain"]),
      currentPageName: computed(() => currentRoute.value.name),
    });

    //* whatch for menu to be open and change the height of the mobile menu
    watch(
      () => state.isActive,
      (isActive) => {
        if (isActive) {
          menuRef.value.style.maxHeight = menuRef.value.scrollHeight + "px";
        } else {
          menuRef.value.removeAttribute("style");
        }
      }
    );

    // watch(
    //   () => [
    //     state.currentPageName,
    //     store.state.purl.id,
    //     store.state.purl.sessionDbId,
    //   ],
    //   ([currentPageName, purlId, sessionDbId]) => {
    //     if (currentPageName && purlId && sessionDbId) {
    //       const currentPageObj = computed(() =>
    //         store.getters["purl/getPageByRouteName"](currentPageName)
    //       );
    //       store.dispatch("purl/purlPageTracking", {
    //         sectionId: currentPageObj.value.id,
    //         purlId,
    //         sessionDbId,
    //       });
    //     }
    //   }
    // );

    //* Methods
    function toggleBurger() {
      state.isActive = !state.isActive;
    }

    return {
      ...toRefs(state),
      toggleBurger,
      menuRef,
    };
  },
};
</script>

<style lang="scss" scoped>
.brand {
  &-link {
    font-family: inherit;
    font-size: 1.75rem;
    font-weight: 700;
    line-height: inherit;
    border: none;
    outline: none;
    color: $color-secondary;
    text-decoration: none;
    text-transform: uppercase;
    text-rendering: optimizeLegibility;
  }
}
.navbar {
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 0.75rem 0;
  border: none;
  outline: none;
  background: $color-highlight;

  .wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: auto;
    margin: 0 auto;
  }

  .burger {
    position: relative;
    display: none;
    cursor: pointer;
    width: 2rem;
    height: 1rem;
    border: none;
    outline: none;
    opacity: 0;
    visibility: hidden;
    background: none;
    transform: rotate(0deg);
    transition: 0.35s ease-in-out;
    @include media_tablet {
      display: block;
      opacity: 1;
      visibility: visible;
    }
    &-line {
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      left: 0;
      border: none;
      outline: none;
      opacity: 1;
      border-radius: 0.25rem;
      background: $color-secondary;
      transform: rotate(0deg);
      transition: 0.25s ease-in-out;

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2),
      &:nth-child(3) {
        top: 0.5rem;
      }

      &:nth-child(4) {
        top: 1rem;
      }
    }

    &.active {
      .burger-line {
        &:nth-child(1),
        &:nth-child(4) {
          top: 1.25rem;
          width: 0%;
          left: 50%;
        }

        &:nth-child(2) {
          transform: rotate(45deg);
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
        }
      }
    }
  }

  .menu {
    @include media_tablet {
      width: 100%;
      max-height: 0rem;
      padding: 0;
      opacity: 0;
      visibility: hidden;
      overflow: hidden;
      transition: all 0.35s ease;
    }
    &.active {
      @include media_tablet {
        opacity: 1;
        visibility: visible;
      }
    }
    &-inner {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 2rem;
      list-style: none;
      margin: 0;
      @include media_tablet {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 0.75rem;
        padding: 1rem 0;
      }
    }
    &-link {
      font-family: inherit;
      font-size: 0.7rem;
      font-weight: 600;
      line-height: inherit;
      border: none;
      text-transform: uppercase;
      text-decoration: none;
      text-rendering: optimizeLegibility;
      transition: all 0.35s ease-in-out;
      color: $color-white;
      &.router-link-active,
      &:hover {
        border: none;
        outline: none;
        color: $color-secondary;
      }
    }
  }
}
</style>
